export class AbstractDBInterfaceImpl {
    dbCloneItem(item) {
        return Object.assign({}, item);
    }
    dbClone(items) {
        if (!items || (Array.isArray(items) && items.length === 0)) {
            return items;
        }
        if (Array.isArray(items)) {
            const ret = [];
            items.forEach(it => {
                ret.push(this.dbCloneItem(it));
            });
            return ret;
        }
        return this.dbCloneItem(items);
    }
    async dbWait(duration = 1000) {
        return new Promise(r => {
            setTimeout(r, duration);
        });
    }
}
